import { render, staticRenderFns } from "./CaratulaManual.vue?vue&type=template&id=349ce20e&scoped=true&"
import script from "./CaratulaManual.vue?vue&type=script&lang=js&"
export * from "./CaratulaManual.vue?vue&type=script&lang=js&"
import style0 from "./CaratulaManual.vue?vue&type=style&index=0&id=349ce20e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ce20e",
  null
  
)

export default component.exports